import type {Recipe} from '../types'

import {useMaterialsRecipes} from './useMaterialsRecipes'

interface UseMaterialsRecipesByIdParams {
  plantId: string
  throwOnError?: boolean
}

export const useMaterialsRecipesById = ({
  plantId,
  throwOnError = true
}: UseMaterialsRecipesByIdParams) =>
  useMaterialsRecipes<Record<string, Recipe>>({
    plantCode: plantId,
    options: {
      select: (data) =>
        data.reduce(
          (recipesById, recipe) => ({...recipesById, [String(recipe.id)]: recipe}),
          {} as Record<string, Recipe>
        ),
      throwOnError
    }
  })
